<template>
    <div>
        <Card shadow>
            <Row :gutter="10">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platids" filterable placeholder="筛选所属分组" clearable multiple :max-tag-count="3" @on-change="updateSelect">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="3">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_ids" filterable placeholder="筛选代理" multiple :disabled="!table.params.platids.length" :max-tag-count="3">
                            <Option v-for="(item, index) in app_list.filter((el) => table.params.platids.length == 0 || table.params.platids.includes(el.platform))" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="8">
                    <label style="display: flex; align-items: center">
                        <span style="width: 100px">查询时间:</span>
                        <DatePicker style="width: 40%" type="date" format="yyyy-MM-dd" v-model="select.dataTime1" placeholder="选择日期" :options="dateOptions" :clearable="false"></DatePicker>
                        <TimePicker style="width: 60%" type="timerange" confirm v-model="select.dataTime2" placeholder="选择时间范围" :clearable="false"></TimePicker>
                    </label>
                </Col>
                <Col span="8">
                    <label style="display: flex; align-items: center">
                        <span style="width: 100px">对比时间:</span>
                        <DatePicker style="width: 40%" type="date" format="yyyy-MM-dd" v-model="select.DdataTime1" placeholder="选择日期" :options="dateOptions" :clearable="false"></DatePicker>
                        <TimePicker style="width: 60%" type="timerange" confirm v-model="select.DdataTime2" placeholder="选择时间范围" :clearable="false"></TimePicker>
                    </label>
                </Col>
            </Row>
            <Row :gutter="18" style="margin-top: 12px">
                <Col style="display: flex; justify-content: space-between; width: 350px">
                    <Button type="primary" @click.native="TransTopReq()" :loading="loading">
                        <span v-if="!loading">查询</span>
                        <span v-else>loading</span>
                    </Button>
                    <div>
                        <Button type="primary" @click.native="eleToExcel()" style="margin-right: 12px"> 导出excel </Button>
                        <Button type="primary" @click.native="toPdf()"> 导出PDF </Button>
                    </div>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" :row-class-name="rowClassName" :max-height="maxHeight" style="margin-top: 12px" ref="tableRef"></Table>
    </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
export default {
    name: 'GameCompare',
    components: { publicTable },
    data() {
        return {
            maxHeight: 700,
            loading: false,
            TransTopReqTimer: null,
            select: {
                dataTime1: this.getCurrentZeroDay(),
                dataTime2: ['00:00:00', '23:59:59'],
                DdataTime1: new Date(this.getCurrentZeroDay().getTime() - 24 * 60 * 60),
                DdataTime2: ['00:00:00', '23:59:59']
            },

            table: {
                params: {
                    mod: 'root',
                    platid: 0,
                    platids: [],
                    app_id: 0,
                    app_name: '',
                    platform: 0,
                    app_ids: [],
                    param: {
                        _mod: 'manager',
                        _func: 'GetGameCompareInfo',
                        _param: { app_id: 0, stime: 0, etime: 0 }
                    }
                },
                data: [],
                columns: [
                    {
                        title: '盘口',
                        key: 'app_name',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => h('div', [h('span', params.row.app_name ? params.row.app_name : ''), h('span', { style: 'color:#bbb' }, params.row.app_id ? `（${params.row.app_id}）` : '')])
                    },
                    { title: '日期', key: 'idate', minWidth: 100, align: 'center' },
                    this.renderCol('new_user_num', '新增人数'),
                    this.renderCol('pay_bet_num', '转入投注人数'),
                    this.renderCol('pay_user_num', '转入人数'),
                    this.renderCol('pay_total_times', '转入金额', true),
                    this.renderCol('r_pay_user_num', '大R人数'),
                    this.renderCol('r_pay_user_sum', '大R转入金额', true)
                    // {
                    //     title: '线上支付成功率',
                    //     key: 'r_pay_rate',
                    //     minWidth: 100,
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         let type = params.row.type;
                    //         let value = params.row.r_pay_rate;
                    //         let color = this.rCol(type, value);
                    //         let color1 = this.rCol(type, params.row.r_pay_user_sum);
                    //         let str = (value * 100).toFixed(2) + '%';
                    //         if (type < 2) return h('span', { style: { color } }, str);
                    //         if (params.row.all == 1) {
                    //             return h('span', { style: { color: color1 } }, str);
                    //         } else {
                    //             return h('span', '-');
                    //         }
                    //     },
                    // },
                ],
                total: 0,
                pageSizes: [10, 20, 30, 40]
            },
            all: this.allInit()
        }
    },
    methods: {
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },

        async TransTopReq() {
            this.all = this.allInit()
            if (this.loading) return
            this.table.params.param._param.stime = this.getSecondResult(moment(this.select.dataTime1).format('YYYY-MM-DD') + ' ' + this.select.dataTime2[0])
            this.table.params.param._param.etime = this.getSecondResult(moment(this.select.dataTime1).format('YYYY-MM-DD') + ' ' + this.select.dataTime2[1])
            this.openTimer()
            let allList = this.getAllHttpAppid(this.table.params)
            this.table.data = []
            let dateMap = {
                count: 0
            }
            let httpList = []
            let loadingArr = [...allList]

            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = this.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                this.table.params.platid = platid
                this.table.params.app_id = app_id
                this.table.params.app_name = app_name
                this.table.params.param._param.app_id = app_id
                let param = this.copyData(this.table.params)
                let param1 = this.copyData(param)
                param1.param._param.stime = this.getSecondResult(moment(this.select.DdataTime1).format('YYYY-MM-DD') + ' ' + this.select.DdataTime2[0])
                param1.param._param.etime = this.getSecondResult(moment(this.select.DdataTime1).format('YYYY-MM-DD') + ' ' + this.select.DdataTime2[1])
                param1.param._func = 'GetGameCompareInfo2'
                httpList.push([param, param1])
            }
            let max = httpList.length
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, dateMap, loadingArr)
            }
        },

        async toHttp(httpList, dateMap, loadingArr) {
            if (httpList.length > 0) {
                let list = httpList.shift()
                let param = list[0]
                let param1 = list[1]
                let num = httpList.length
                TransTopReq(param)
                    .then((res) => {
                        dateMap.count++
                        let obj = res._param
                        let dateName = moment(this.select.dataTime1).format('YYYY-MM-DD')
                        obj.idate = dateName
                        obj.app_id = param.app_id
                        obj.app_name = param.app_name
                        obj.type = 0
                        delete obj.data
                        this.all[0].idate = moment(this.select.dataTime1).format('YYYY-MM-DD')
                        this.all[0].new_user_num += obj.new_user_num
                        this.all[0].pay_bet_num += obj.pay_bet_num
                        this.all[0].pay_user_num += obj.pay_user_num
                        this.all[0].pay_total_times += obj.pay_total_times
                        this.all[0].r_pay_user_num += obj.r_pay_user_num
                        this.all[0].r_pay_user_sum += obj.r_pay_user_sum
                        this.all[0].down_pay_success_num += obj.down_pay_success_num
                        this.all[0].down_pay_all_num = obj.down_pay_all_num
                        this.all[0].r_pay_rate = this.all[0].down_pay_all_num ? this.all[0].down_pay_success_num / this.all[0].down_pay_all_num : 0
                        TransTopReq(param1).then((res1) => {
                            let obj1 = res1._param
                            let dateName1 = moment(this.select.DdataTime1).format('YYYY-MM-DD')
                            obj1.idate = dateName1
                            obj1.type = 0
                            delete obj.data

                            this.all[1].idate = dateName1
                            this.all[1].new_user_num += obj1.new_user_num
                            this.all[1].pay_bet_num += obj1.pay_bet_num
                            this.all[1].pay_user_num += obj1.pay_user_num
                            this.all[1].pay_total_times += obj1.pay_total_times
                            this.all[1].r_pay_user_num += obj1.r_pay_user_num
                            this.all[1].r_pay_user_sum += obj1.r_pay_user_sum
                            this.all[1].down_pay_success_num += obj1.down_pay_success_num
                            this.all[1].down_pay_all_num = obj1.down_pay_all_num
                            this.all[1].r_pay_rate = this.all[1].down_pay_all_num ? this.all[1].down_pay_success_num / this.all[1].down_pay_all_num : 0

                            let obj2 = {
                                type: 1,
                                app_name: '',
                                idate: '差值',
                                new_user_num: obj.new_user_num - obj1.new_user_num,
                                pay_bet_num: obj.pay_bet_num - obj1.pay_bet_num,
                                pay_user_num: obj.pay_user_num - obj1.pay_user_num,
                                pay_total_times: obj.pay_total_times - obj1.pay_total_times,
                                r_pay_user_num: obj.r_pay_user_num - obj1.r_pay_user_num,
                                r_pay_user_sum: obj.r_pay_user_sum - obj1.r_pay_user_sum,
                                r_pay_rate: obj.r_pay_rate - obj1.r_pay_rate
                            }

                            let obj3 = {
                                new_user_num: obj1.new_user_num ? obj2.new_user_num / obj1.new_user_num : 0,
                                pay_bet_num: obj1.pay_bet_num ? obj2.pay_bet_num / obj1.pay_bet_num : 0,
                                pay_user_num: obj1.pay_user_num ? obj2.pay_user_num / obj1.pay_user_num : 0,
                                pay_total_times: obj1.pay_total_times ? obj2.pay_total_times / obj1.pay_total_times : 0,
                                r_pay_user_num: obj1.r_pay_user_num ? obj2.r_pay_user_num / obj1.r_pay_user_num : 0,
                                r_pay_user_sum: obj1.r_pay_user_sum ? obj2.r_pay_user_sum / obj1.r_pay_user_sum : 0,
                                r_pay_rate: '-'
                            }
                            this.getRateColor(obj3)
                            Object.assign(obj3, {
                                type: 2,
                                app_name: '',
                                idate: '环比'
                            })

                            this.all[2].type = 1
                            this.all[2].idate = '差值'
                            this.all[2].new_user_num = this.all[0].new_user_num - this.all[1].new_user_num
                            this.all[2].pay_bet_num = this.all[0].pay_bet_num - this.all[1].pay_bet_num
                            this.all[2].pay_user_num = this.all[0].pay_user_num - this.all[1].pay_user_num
                            this.all[2].pay_total_times = this.all[0].pay_total_times - this.all[1].pay_total_times
                            this.all[2].r_pay_user_num = this.all[0].r_pay_user_num - this.all[1].r_pay_user_num
                            this.all[2].r_pay_user_sum = this.all[0].r_pay_user_sum - this.all[1].r_pay_user_sum
                            this.all[2].r_pay_rate = this.all[0].r_pay_rate - this.all[1].r_pay_rate

                            this.all[3].type = 2
                            this.all[3]['all'] = 1
                            this.all[3].idate = '环比'
                            this.calcForEach(this.all[3], this.all[2], this.all[1], ['new_user_num', 'pay_bet_num', 'pay_user_num', 'pay_total_times', 'r_pay_user_num', 'r_pay_user_sum', 'r_pay_rate'])

                            this.table.data.splice(this.table.data.length - 4, this.table.data.length)
                            this.table.data.push(...[obj, obj1, obj2, obj3])
                            this.table.data = this.table.data.concat(this.all)
                            loadingArr.shift()
                            if (loadingArr.length == 0) {
                                this.closeTimer()
                            }
                            this.toHttp(httpList, dateMap, loadingArr)
                        })
                    })
                    .catch((err) => {
                        this.toHttp(httpList, dateMap, loadingArr)
                    })
            }
        },
        getOffsetColor(obj) {
            let cellClassName = {}
            for (let i in obj) {
                if (obj[i] < 0) {
                    cellClassName[i] = 'red'
                }
            }
            Object.assign(obj, { cellClassName })
        },
        getRateColor(obj) {
            let cellClassName = {}
            let from = { ...obj }
            delete from.type
            delete from.app_name
            delete from.idate
            delete from.r_pay_rate
            for (let i in from) {
                let val = from[i]
                if (val <= -0.1) {
                    cellClassName[i] = 'red1'
                } else if (val > -0.1 && val <= -0.05) {
                    cellClassName[i] = 'red2'
                } else if (val < 0) {
                    cellClassName[i] = 'red3'
                }
            }
            Object.assign(obj, { cellClassName })
        },
        rowClassName(row, index) {
            let type = Math.floor(index / 4)
            let result = type % 2
            if (result == 0) {
                return ''
            } else {
                return 'back-split'
            }
        },
        calcForEach(val1, val2, val3, types) {
            let cellClassName = {}
            for (let type of types) {
                val1[type] = val3[type] ? val2[type] / val3[type] : 0
                let val = val1[type]
                if (val <= -0.1) {
                    cellClassName[type] = 'red1'
                } else if (val > -0.1 && val <= -0.05) {
                    cellClassName[type] = 'red2'
                } else if (val < 0) {
                    cellClassName[type] = 'red3'
                }
            }
            Object.assign(val1, { cellClassName })
        },
        toPdf() {
            this.maxHeight = null
            this.$nextTick(async () => {
                await this.eleToPdf()
                this.maxHeight = 700
            })
        },
        //分组变化清空盘口选择项
        updateSelect() {
            this.table.params.app_ids = []
        },
        rColItem(h, params, isMoney = false) {
            let field = params.column.key
            let value = params.row[field]
            let type = params.row.type
            if (isMoney && type < 2) {
                value = this.getCustomFixed(value / 10000)
            }
            let color = this.rCol(type, value)
            let str = type < 2 ? value : (value * 100).toFixed(2) + '%'
            return h('span', { style: { color } }, str)
        },
        rCol(type, num) {
            if (type == 1 && num < 0) return 'red'
            return '#333'
        },
        renderCol(key, title, ispoint = false) {
            return {
                title,
                key,
                minWidth: 100,
                align: 'center',
                render: (h, params) => this.rColItem(h, params, ispoint)
            }
        },
        allInit() {
            return [this.getAllItem('合计', 0), this.getAllItem('', 0), this.getAllItem('', 1), this.getAllItem('', 1)]
        },
        getAllItem(app_name = '', type = 0) {
            return {
                type,
                app_name,
                idate: '',
                down_pay_all_num: 0,
                down_pay_success_num: 0,
                new_user_num: 0,
                pay_bet_num: 0,
                pay_user_num: 0,
                pay_total_times: 0,
                r_pay_user_num: 0,
                r_pay_user_sum: 0,
                r_pay_rate: 0
            }
        },
        initFunc() {
            let arr = [this.getinitPlatId()]
            this.table.params.platids = arr
            this.TransTopReq()
        },
        initTimes() {
            let date = new Date(this.getSecondResult(new Date()) * 1000)
            let hours = date.getHours() - 1
            let isFloor = false
            if (hours == -1) {
                isFloor = true
                hours = 23
            }
            let str = hours > 10 ? hours : `0${hours}`
            return {
                isFloor,
                data: ['00:00:00', `${str}:59:59`]
            }
        },
        initDateTime() {
            let date1 = this.initTimes()
            let date2 = this.initTimes()
            if (date2.isFloor) {
                this.select.dataTime1 = new Date(this.select.dataTime1.getTime() - 24 * 60 * 60)
                this.select.DdataTime1 = new Date(this.select.dataTime1.getTime() - 24 * 60 * 60)
            }
            this.select.dataTime2 = date1.data
            this.select.DdataTime2 = date2.data
        }
    },

    created() {
        this.initDateTime()
        this.initFunc()
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
/deep/ .ivu-table .red1 {
    background-color: rgb(244, 176, 132) !important;
}
/deep/ .ivu-table .red2 {
    background-color: rgb(255, 204, 0) !important;
}
/deep/ .ivu-table .red3 {
    background-color: rgb(255, 255, 153) !important;
}
/deep/ .ivu-table .back-split td {
    background-color: rgb(210, 238, 243);
}
/deep/ .ivu-table-border th {
    border-right: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table-border td {
    border-right: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table th {
    border-bottom: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table td {
    border-bottom: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table-wrapper-with-border {
    border: 1px solid rgb(145, 145, 145) !important;
}
</style>
